import MarketingAccountMatchesView from './MarketingAccountMatchesView';

export default MarketingAccountMatchesView;
